import moment from "moment";
import { SBDatePicker } from "../UiComponents/SBDatePicker";
import React, { useEffect, useState } from 'react';
import { SBAComboBox, SBAMultiSelect } from "../UiComponents/SBADropDown";
import { GetReportParamDataSource } from "./Reporting";



export const GetUIController = ({ list, setList }) => {
  return (
    <div className="row ReportDyanmicContrllersSection">
      {list.map((item, index) => (
        <div key={index} className="col-6 col-md-3" 
        style={{ display: item.Prompt === "" && "none" }}
        >
          {item.Prompt !== "" && (() => {
        let component = null;

        switch (item.ParameterTypeName) {
          case "Boolean":
            component = <ReportRadioButton item={item} setList={setList} />;
            break;

          case "DateTime":
            component = <ReportDatePicker item={item} setList={setList} />;
            break;

          case "String":
          case "Integer":
            if(item.ValidValuesQueryBased && item.MultiValue)
            component = <ReportMultiselectComboBox item={item} setList={setList} list={list} />;
            else if (item.ValidValuesQueryBased || item.ValidValues) {
              component = <ReportComboBox item={item} setList={setList} list={list} />;
            }else {
              component = <ReportTextEditor item={item} setList={setList} list={list} />;
            }
            break;

          default:
            component = null; 
        }

        return (
          <>
            {component}
          </>
        );
      })()}
        </div>
      ))}
    </div>
  );
};

const ReportDatePicker = ({ item, setList }) => {
  const [dateValue,setDateValue]=useState(moment(item?.DefaultValues[0]));
  useEffect(()=>{
    setDateValue(value=>moment(item?.DefaultValues[0]));
  },[item])
  const HandleOnChange=(event)=>{
    setDateValue(moment(event.toDate()));
    setList(value=>(value.map(Litem=>{
      if(Litem.Name===item.Name)
      {
        Litem.DefaultValues=[];
        const dateString=moment(event).format('MM-DD-YYYY');
        Litem.DefaultValues[0]=dateString;
      return item;
      }
      else 
      return Litem;
    })))
  }

  return <>
    <>
      <label className="mb-1 label">{item.Prompt}</label>
      <div>
        <SBDatePicker onChange={(e)=>{HandleOnChange(e)}} value={dateValue} />
      </div>
    </>
  </>
};


const ReportRadioButton = ({ item, setList }) => {
  const HandleOnChange=(event,valueString)=>{
    setList(value=>(value.map(Litem=>{
      if(Litem.Name===item.Name)
      {
        Litem.DefaultValues=[];
        Litem.DefaultValues[0]=valueString;
      return item;
      }
      else 
      return Litem;
    })))
  }
  return <>
    <label className="mb-1 label">{item.Prompt}</label>
    <div>
      <input type="radio" name={item.Name} className="mx-2" onChange={(e)=>{HandleOnChange(e,'True')}} checked={item.DefaultValues[0]=="True"} /> True
      <input type="radio" name={item.Name} className="mx-2" onChange={(e)=>{HandleOnChange(e,'False')}} checked={item.DefaultValues[0]=="False"}/> False
    </div>
  </>
};


const ReportTextEditor = ({ item, setList,list }) => {
  const HandleOnChange=(event)=>{
    // setTextValue(event.target.value);
    setList(value=>(value.map(Litem=>{
      debugger;
      if(Litem.Name===item.Name)
      {
        Litem.DefaultValues=[];
        Litem.DefaultValues[0]=event.target.value;
      return item;
      }
      else 
      return Litem;
    })))
  }
  return <>
    <label className="mb-1 label">{item.Prompt}</label>
    <div>
      <input type="text" className="form-control" defaultValue={item?.DefaultValues[0]} onBlur={(e)=>{HandleOnChange(e)}} />
    </div>
  </>
};


const ReportComboBox = ({item, setList ,list}) => { 
  const ddData = item?.Dataset || item?.ValidValues || [];
  const HandleOnChange = async (event) => {
    if (!event?.value) return;
    const updatedList = await Promise.all(
      list.map(async (Litem) => {
        let updatedItem = { ...Litem };
        if (Litem.Name === item.Name) {
          updatedItem.selectedValue = event.value;
          updatedItem.dataToPass=event.value.Value;

        }
        if (item?.ChildControl?.includes(Litem.Name)) {
          if (Litem?.ValidValuesQueryBased === true) {
            updatedItem.selectedValue=updatedItem?.MultiValue === false ? {Label:'', Value:''}: [];
            updatedItem.Dataset = await GetReportParamDataSource(Litem?.ReportUrl,Litem.Name,event?.value?.Value);
          }
        }
        return updatedItem;
      })
    );

    setList(updatedList);
  };

  const defaultVal = ()=>{
    const defV = item.DefaultValues[0];
    return item.ValidValues?.find((val) => val.Value ===defV);
  };
  useEffect(() => {
    if(item?.selectedValue?.Value === '')
    {
      HandleOnChange({value:item?.selectedValue})
    }
  }, [item?.selectedValue]);
  
  return <>
    <label className="mb-1 label">{item.Prompt}</label>
    <div>
      <SBAComboBox 
        data={ddData}
        textField={'Label'}
        valueField={'Value'}
        onChange={(e)=>{HandleOnChange(e)}}
        value={item?.selectedValue || defaultVal()}
        placeholder="Please Select"
      />
    </div>
  </>
}

// 

const ReportMultiselectComboBox = ({item, setList ,list}) => {
  const ddData = item?.Dataset || item?.ValidValues || [];
  const [defaultSelectedVal, SetDefaultSelectedVal] = useState(item?.selectedValue);
  const HandleOnChange = async (event) => {
    if (!event?.value) return;
    const updatedList = await Promise.all(
      list.map(async (Litem) => {
        let updatedItem = { ...Litem };
        if (Litem.Name === item.Name) {
          updatedItem.selectedValue = event.value.find(item=>item.Value==-1) ? [] :event.value;
          updatedItem.dataToPass=event.value.length>0 ? event.value.map(item=>item.Value).join(","): "-1"
        }
        if (item.ChildControl?.includes(Litem.Name)) {
          if (Litem?.ValidValuesQueryBased === true) {
            updatedItem.selectedValue=null
            const paramData=event.value.find(item=>item.Value==-1) ? "-1" :event.value.map(item=>item.Value).join(",");
            updatedItem.Dataset = await GetReportParamDataSource(Litem?.ReportUrl,Litem.Name,paramData);
          }
        }
        return updatedItem;
      })
    );
    setList(updatedList);
  };

  useEffect(() => {
    const parentItem = list.find((Litem) =>
     Array.isArray(Litem.ChildControl) &&
     Litem.ChildControl.includes(item.Name)
    );
    if (parentItem?.selectedValue?.Value === '') return;
    else{
      if (item?.MultiValue === true && ddData.length > 0) {
        const defaultVals = ddData.filter(item => item.Value !== -1);
        
        const updatedList = list.map((Litem) => {
          if (Litem.Name === item.Name) {
            return {
              ...Litem,
              selectedValue: defaultVals,
              dataToPass: defaultVals.map(item => item.Value).join(","),
            };
          }
          return Litem;
        });
  
        const simualtedEvent = {
          value: defaultVals
        };
    
        HandleOnChange(simualtedEvent);
        SetDefaultSelectedVal(defaultVals);
        setList(updatedList);
      }
    }
  }, [item?.MultiValue, ddData]);
  
  
  return <>
    <label className="mb-1 label">{item.Prompt}</label>
    <div>
      <SBAMultiSelect 
        data={ddData}
        textField={'Label'}
        valueField={'Value'}
        onChange={(e)=>{HandleOnChange(e)}}
        value={item?.selectedValue || defaultSelectedVal}
        tags={
          item?.selectedValue?.length > 0
              ? [{ text: `${item?.selectedValue.length} items selected`, data: [...item?.selectedValue] }]
              : []
        }
      />
    </div>
  </>
}